export type QueryOperator = "AND" | "OR";
